<template>
  <div class="relative">
    <span
      class="material-icons absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
      >search</span
    >
    <input
      type="text"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      class="w-full pl-12 pr-4 py-3 bg-white rounded-xl border border-gray-200 focus:border-[#FF5722] focus:ring-1 focus:ring-[#FF5722] outline-none transition-colors"
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: "Pesquisar por ID ou localização..."
    }
  }
};
</script>
